<template>
  <div>
    <div :id="id" :style="reportStyle" :width="width" class="_pbiReport" />
  </div>
</template>

<script>
import * as pbi from "powerbi-client";

export default {
  props: {
    id: {
      type: String,
      default: "reportContainer"
    },
    reportId: {
      type: String,
      default: ""
    },
    filterPaneEnabled: {
      type: Boolean,
      default: false
    },
    navContentPaneEnabled: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "541px"
    },
    datasource: {
      type: String,
      default: ""
    },
    params: {
      type: Object,
      default: () => null
    },
    pagination: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    reportStyle() {
      return `height: ${this.height}`;
    }
  },
  async mounted() {},
  methods: {
    render: function(reportId, token, embedUrl, filters) {
      var permissions = pbi.models.Permissions.All;

      let filterList = [];
      for (let i = 0; i < filters.length; i++) {
        let filter = {
          $schema: "http://powerbi.com/product/schema#basic",
          target: {
            table: filters[i].table,
            column: filters[i].column
          },
          operator: "In",
          values: [filters[i].value],
          filterType: pbi.models.FilterType.Basic
        };

        if (filter.values != undefined && filter.values.length > 0) {
          filterList.push(filter);
        }
      }
      var config = {
        type: "report",
        tokenType: pbi.models.TokenType.Embed,
        accessToken: token,
        embedUrl: embedUrl,
        id: reportId,
        permissions: permissions,
        height: 542,
        filters: filterList,
        settings: {
          navContentPaneEnabled: false,
          bars: {
            actionBar: {
              visible: false
            }
          },
          panes: {
            bookmarks: {
              visible: false
            },
            fields: {
              expanded: false
            },
            filters: {
              expanded: false,
              visible: false
            },
            pageNavigation: {
              visible: this.pagination
            },
            selection: {
              visible: false
            },
            syncSlicers: {
              visible: false
            },
            visualizations: {
              expanded: false
            }
          },
          height: 541.25
        }
      };

      var container = document.getElementById(this.id);

      const powerbiService = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );

      // Reset the embeded report
      powerbiService.reset(container);

      // Embed the report and display it within the div container.
      var report = powerbiService.embed(container, config);

      // Report.off removes a given event handler if it exists.
      report.off("loaded");

      // Report.off removes a given event handler if it exists.
      report.off("rendered");

      report.off("saved");
    }
  }
};
</script>

<style lang="scss" scoped>
.header-title h1.title {
  text-align: left;
  letter-spacing: 0px;
  color: #1c1d21;
  opacity: 1;
  font-size: 24px;
  font-weight: bold;
}
</style>

<style>
._pbiReport iframe {
  border: none;
}
</style>
